import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext.jsx";
import { useAuth } from "../context/AuthContext.jsx";
import { LAUNCH_PLAN_ID } from "../data/products.js";

// Shared by every "join the ₹9 plan" CTA (welcome popup, launch band). The
// plan is unlisted from the catalog, so clicking one of these CTAs is the
// only way it ever reaches the cart — add it straight away, then send the
// customer to finish: signed-in visitors go to checkout, everyone else
// registers first (checkout requires an account) and lands back on checkout
// with the plan already waiting in their cart.
export function useJoinLaunchPlan() {
  const { add } = useCart();
  const { user } = useAuth();
  const navigate = useNavigate();

  return () => {
    add(LAUNCH_PLAN_ID);
    navigate(user ? "/checkout" : "/signup?next=/checkout");
  };
}
